import type { ReactNode } from 'react'
import { useIntl } from 'react-intl'

import { Alert, Button, cn } from '@/shared/ui'

/** Says something could not be loaded, announced at once, with a retry when one is given. */
export function ErrorState(props: {
  readonly title: string
  readonly children?: ReactNode
  readonly onRetry?: () => void
  readonly className?: string
}) {
  const intl = useIntl()

  return (
    <Alert severity="error" title={props.title} className={cn(props.className)}>
      {props.children !== undefined && <p className="mt-1">{props.children}</p>}
      {props.onRetry !== undefined && (
        <Button variant="outlined" size="small" onClick={props.onRetry} className="mt-3">
          {intl.formatMessage({ id: 'shell.retry' })}
        </Button>
      )}
    </Alert>
  )
}
